import Types from "./Types";

const INITIAL_STATE = {
  markSchemes: [],
  isLoading: false,
  count: 0,
};

export default function markSchemes(state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case Types.GET_MARK_SCHEMES_SUCCESS: {
      // Controller returns a plain array
      const list = Array.isArray(payload)
        ? payload
        : Array.isArray(payload?.data)
          ? payload.data
          : [];
      return {
        ...state,
        markSchemes: list,
        count: list.length,
      };
    }

    case Types.REGISTER_MARK_SCHEME_SUCCESS: {
      const updated = payload?.data;
      const url = payload?.url ?? updated?.url;
      const id = updated?.id;
      const markSchemes = state.markSchemes.map((item) => {
        const match =
          (id != null && item.id === id) ||
          (url != null && item.url === url);
        if (!match) return item;
        return {
          ...item,
          ...(updated && typeof updated === "object" ? updated : {}),
        };
      });
      return {
        ...state,
        markSchemes,
      };
    }

    case Types.ADD_MARK_SCHEMES_LOADING: {
      return {
        ...state,
        isLoading: payload,
      };
    }

    default: {
      return state;
    }
  }
}
